const Colors = {
  primary: '#D68F1D',
  secondary: '#12141D',
  outline: '#F9E5C5',
  outline2: '#ECECF2',
  background: '#FFF6E8',
  background2: '#FAFBFF',
  lightText: '#92929D',
  text_icon: '#8F95B2',
  text_icon2: '#FE7C4B',
  pageHeading_icon: '#526380',
  deletionRequestedHead: '#DB0202',
  deletionRequestedBackground: ':#F8FAFB',
  deletionRequestedOutline: '#E2E3E6',
  sidebarBgColor:
    'linear-gradient(89.71deg, rgb(214,143,29, 0.35) 0.21%, rgb(222,184,143,0.35) 31.47%, rgb(214,143,29, 0.35)  103.7%)',
  success: 'green',
  lightModeBorderColor: 'rgba(224, 224, 224, 1)',
};

const DarkmodeColors = {
  sidebarBgColor: '#17223B',
  textColor: '#FFFFFF',
  arrowIcon: '#959595',
  menuIcon: '#526380',
  appBar: '#17223b',
  datagridTableHeader: '#151C2B',
  datagridTablebgColor: '#202C47',
  darkText: '#8F95B2',
  darkContainer: '#202c47',
  darkText_d: '#8A90AD',
};

const ColorsV2 = {
  primary: '#191429',
  secondary: '#221B39',
  white: '#ffffff',
  acent: '#E24BE6',
  outline: '#6D6586',
  paleLime: '#BFEB7E',
  pink: '#F085E4',
  textInfo: '#c2c2d6',
};

export { Colors, DarkmodeColors, ColorsV2 };
